/* =========================================================
   Vulnor — theme scripts
   Progressive enhancement only: every feature here has a
   working no-JS fallback in the Liquid.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('.product-media__slide');
    var thumbs = document.querySelectorAll('[data-thumb-for]');
    if (thumbs.length === 0) return;

    function show(mediaId) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });
      thumbs.forEach(function (thumb) {
        var on = thumb.dataset.thumbFor === mediaId;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(thumb.dataset.thumbFor);
      });
    });

    // Arrow-key navigation across thumbnails.
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = thumbs[index + 1];
        if (event.key === 'ArrowLeft') next = thumbs[index - 1];
        if (!next) return;
        event.preventDefault();
        next.focus();
        show(next.dataset.thumbFor);
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariants() {
    var select = document.querySelector('[data-variant-select]');
    if (!select) return;

    var idField = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var buttonPrice = document.querySelector('[data-button-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (idField) idField.value = option.value;
      if (priceEl) priceEl.textContent = option.dataset.price || '';
      if (buttonPrice) buttonPrice.textContent = option.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (compareEl) {
        var compare = option.dataset.compare;
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }
    });
  }

  /* ---------- Direct-to-checkout buy button ----------
     Clears whatever is in the cart, adds the selected variant,
     then goes straight to checkout. If anything fails, the form
     submits normally and Shopify's return_to takes over.
  ------------------------------------------------------ */
  function initBuyNow() {
    var form = document.querySelector('#product-form, form[action*="/cart/add"]');
    var button = document.querySelector('[data-buy-now]');
    if (!form || !button) return;

    var skipCart = form.dataset.skipCart !== 'false';
    var replaceCart = form.dataset.replaceCart !== 'false';
    if (!skipCart) return;

    form.addEventListener('submit', function (event) {
      // Add to cart button, when shown, keeps the default behaviour
      // and must not inherit the straight-to-checkout redirect.
      if (event.submitter && event.submitter.hasAttribute('data-add-to-cart')) {
        var returnTo = form.querySelector('[data-return-to]');
        if (returnTo) returnTo.remove();
        return;
      }
      if (!window.fetch) return;

      event.preventDefault();
      if (button.classList.contains('is-loading')) return;

      var idField = form.querySelector('[name="id"]');
      if (!idField || !idField.value) {
        form.submit();
        return;
      }

      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      var step = replaceCart
        ? fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        : Promise.resolve();

      step
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(idField.value), quantity: 1 }] })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          // Network hiccup or sold out: let Shopify handle it the normal way.
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          form.submit();
        });
    });
  }

  /* ---------- Sticky mobile buy bar ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-sticky-buy]');
    var buyButton = document.querySelector('[data-buy-now]');
    if (!bar || !buyButton) return;

    var trigger = bar.querySelector('[data-sticky-buy-btn]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        buyButton.click();
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -40% 0px' }
    );
    observer.observe(buyButton);
  }

  /* ---------- FAQ: one answer open at a time ---------- */
  function initFaq() {
    var items = document.querySelectorAll('.faq > .faq-item');
    if (items.length < 2) return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function init() {
    initGallery();
    initVariants();
    initBuyNow();
    initStickyBar();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
